module.exports = __webpack_public_path__ + "img/img_logo_chrome.40fd49a.svg";